
import { Placement } from '@post-office/placements-frontend/test-placement-v2-example';
export default Placement;
